import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { insuranceResource } from './../../../insurance/insuranceManage/request';
import { claimsField, recordExport } from './../request';
import { downloadFileFun, LANGUAGE_RESOURCE } from '@/utils/public';
export default {
  components: {
    topTitle
  },
  props: {
    previewVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      insuranceId: undefined,
      insuranceList: [],
      isShow: false,
      checkedList: [],
      indeterminate: true,
      checkAll: false,
      fieidOptions: []
    };
  },
  created() {
    insuranceResource({
      claims: 'true'
    }).then(res => {
      console.log(res);
      this.insuranceList = res;
    });
  },
  methods: {
    async insuranceChange() {
      const res = await claimsField({
        insuranceId: this.insuranceId
      });
      this.isShow = true;
      this.checkedList = [];
      this.fieidOptions = [];
      res.field.map(item => {
        if (item.type == 'fixedField') {
          this.checkedList.push(item.name);
        }
        this.fieidOptions.push(item.name);
      });
    },
    onChange(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.fieidOptions.length;
      this.checkAll = checkedList.length === this.fieidOptions.length;
    },
    onCheckAllChange(e) {
      console.log(e);
      Object.assign(this, {
        checkedList: e.target.checked ? this.fieidOptions : [],
        indeterminate: false,
        checkAll: e.target.checked
      });
      console.log(this.fieidOptions);
    },
    async handleSure() {
      console.log(this.checkedList);
      if (!this.insuranceId) {
        this.$message.error(this.$t('请先选择保险'));
        return false;
      }
      if (this.checkedList.length == 0) {
        this.$message.error(this.$t('请选择导出的内容'));
        return false;
      }
      const locale = sessionStorage.getItem('locale') || 'zh_CN';
      const language = LANGUAGE_RESOURCE[locale];
      const res = await recordExport({
        insuranceId: this.insuranceId,
        fields: this.checkedList.join(','),
        language
      });
      const nameObj = this.insuranceList.filter(item => item.id == this.insuranceId)[0];
      downloadFileFun(res, 'application/vnd.ms-excel', nameObj.name + '-' + this.$t('理赔记录') + '.xlsx');
      this.$emit('cancel');
    }
  }
};